import { Controller } from "@hotwired/stimulus"
import { badgeClasses } from '@/utils/badge_classes'

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.timeout = null
    this.resultsDiv = null
    this.inputElement = this.element.querySelector('input[type="text"]')

    // Add click outside listener to close results
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.boundHandleClickOutside)
  }

  search(event) {
    clearTimeout(this.timeout)

    const query = event.target.value.trim()
    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`)
        .then(response => response.json())
        .then(data => this.showResults(data, event.target))
        .catch(error => {
          console.error('Autocomplete error:', error)
          this.hideResults()
        })
    }, 300)
  }

  showResults(types, inputElement) {
    this.hideResults()

    if (types.length === 0) return

    this.resultsDiv = document.createElement('div')
    this.resultsDiv.className = 'autocomplete-results list-group position-absolute w-100 shadow'
    this.resultsDiv.style.zIndex = '1050'
    this.resultsDiv.style.maxHeight = '250px'
    this.resultsDiv.style.overflowY = 'auto'
    this.resultsDiv.style.top = '100%'
    this.resultsDiv.style.left = '0'

    types.forEach(type => {
      const item = document.createElement('a')
      item.href = '#'
      item.className = 'list-group-item list-group-item-action d-flex justify-content-between align-items-center'

      const nameSpan = document.createElement('span')
      nameSpan.textContent = type.name
      item.appendChild(nameSpan)

      const badge = document.createElement('span')
      badge.className = badgeClasses({ variant: 'secondary' })
      badge.textContent = `${type.usage_count}x`
      badge.title = `Used ${type.usage_count} times`
      item.appendChild(badge)

      item.addEventListener('click', (e) => {
        e.preventDefault()
        inputElement.value = type.name
        this.hideResults()
        inputElement.focus()
      })

      this.resultsDiv.appendChild(item)
    })

    // Position relative to input's parent
    const parentDiv = inputElement.parentElement
    parentDiv.style.position = 'relative'
    parentDiv.appendChild(this.resultsDiv)
  }

  hideResults() {
    if (this.resultsDiv) {
      this.resultsDiv.remove()
      this.resultsDiv = null
    }
  }

  handleClickOutside(event) {
    if (this.resultsDiv && !this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  disconnect() {
    this.hideResults()
    document.removeEventListener('click', this.boundHandleClickOutside)
  }
}
